import { useLeanspaceAPI } from "@leanspace/js-client/dist/react";
import { useQuery } from "react-query";

export const useTenants = () => {
  const { tenants } = useLeanspaceAPI();
  return useQuery(["tenants"], () =>
    tenants.getAll({
      size: 100,
    })
  );
};

export const useTenant = (id: string) => {
  const { tenants } = useLeanspaceAPI();
  return useQuery(["tenant", id], () => tenants.get(id));
};
